import { isProxy } from '../guards/isProxy';
import { ProxySymbol } from '../values/createProxy';

export const unwrapProxy = <T>(obj: T): T => {
   return isProxy(obj) ? obj[ProxySymbol] : obj;
};
